<style scoped>
.el-collapse-item__header {
  padding-left: 15px;
}

.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}

.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}

.v-modal {
  z-index: 100 !important;
}

.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

.management-list {
  display: flex;
  align-items: center;
  /* margin-bottom: 15px; */
}

.select-department {
  color: green;
  text-decoration: underline;
  cursor: pointer;
}

.management-name {
  flex-shrink: 0;
}

.designee {
  padding: 3px 10px 6px 10px;
  display: inline-block;
  border: 1px solid grey;
  box-sizing: border-box;
  line-height: 20px;
  margin-right: 10px;
}

.input-item {
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-bottom: 20px;
}

.input-item .input-title {
  margin-right: 14px;
}

.add {
  text-align: left;
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
}

.del {
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 10px;
}

.product-item {
  display: flex;
  margin-top: 10px;
}

.product {
  display: flex;
  align-items: center;
}

.product-img {
  width: 60px;
  height: 60px;
  margin-right: 15px;
}

.product-text {
  width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.task-precent {
  width: 70px;
  height: 20px;
  margin: 0 10px;
}
.search-area-div {
  width: 100px;
  text-align: right;
  padding-right: 5px;
}
.search-area .ipt-sty {
  flex: 1;
}
.el-col-6 {
  padding: 0 !important;
  display: flex;
}

</style>
<template>
  <div class="task-content " style="margin-top:1px;">
    <!-- 查询开始 -->
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div">任务编码</div>
          <el-input v-model="page.taskCode" clearable size="mini" class="ipt-sty" placeholder="请输入任务编码"></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">任务名称</div>
          <el-select size="mini" multiple collapse-tags reserve-keyword class="ipt-sty" v-model="page.taskContentName"
            filterable clearable placeholder="请选择任务名称">
            <el-option v-for="(item, index) in taskContentList" :key="index" :label="item.taskContentName"
              :value="item.taskContentName">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">任务大类</div>
          <el-select size="mini" class="ipt-sty" v-model="page.taskTypeGuid" filterable clearable placeholder="请选择任务大类">
            <el-option v-for="(item, index) in taskTypeList" :key="index" :label="item.paramName" :value="item.guid">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="text" @click="showMore = !showMore"
            :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'">
            {{ showMore ? '收起筛选' : '更多筛选' }}
          </el-button>
          <el-button size="mini" type="info" @click="searchData">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="24" v-show="showMore">
        <el-col :span="6">
          <div class="search-area-div">产品类别</div>
          <el-select size="mini" multiple collapse-tags class="ipt-sty" v-model="page.goodsCategoryJson" filterable
            clearable placeholder="请选择产品类别">
            <el-option v-for="item in getCodeListByKey('超级模版-对应产品类别')" :key="item.value" :label="item.text"
              :value="item.value"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">产品分类</div>
          <el-select size="mini" multiple collapse-tags class="ipt-sty" v-model="page.staffCategoryJson" filterable
            clearable placeholder="请选择产品分类">
            <el-option v-for="item in getCodeListByKey('超级模版-对象分类')" :key="item.value" :label="item.text"
              :value="item.value"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">市场分类</div>
          <el-select size="mini" multiple collapse-tags class="ipt-sty" v-model="page.marketingCategoryJson" filterable
            clearable placeholder="请选择市场分类">
            <el-option v-for="item in getCodeListByKey('超级模版-市场分类')" :key="item.value" :label="item.text"
              :value="item.value"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">启用状态</div>
          <el-select size="mini" class="ipt-sty" v-model="page.bizState" filterable placeholder="请选择启用状态">
            <el-option v-for="item in superStateList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">是否智能计算</div>
          <el-select size="mini" class="ipt-sty" v-model="page.isSmartCalculate" filterable clearable placeholder="请选择">
            <el-option v-for="(item) in getCodeListByKey('是否')" :key="item.value" :label="item.text"
              :value="item.value"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">终端类型分类</div>
          <el-select size="mini" multiple collapse-tags class="ipt-sty" v-model="page.terminalTypeClassificationJson" filterable
            clearable placeholder="请选择产品类别">
            <el-option v-for="item in getCodeListByKey('终端类型分类')" :key="item.value" :label="item.text"
              :value="item.value"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">排序规则</div>
          <el-select size="mini" class="ipt-sty" v-model="page.orderByRule" filterable placeholder="请选择">
            <el-option v-for="(item) in sortOptions" :key="item.value" :label="item.name"
              :value="item.value"></el-option>
          </el-select>
        </el-col>
      </el-row>
    </div>
    <!-- 查询结束 -->
    <!-- 表单开始 -->
    <div class="back-color-fff content-main-box" :style="'height:' + contentMainHeight + 'px;'">
      <div class="button-area" style="padding-top:8px;">
        <el-button icon="el-icon-plus" size="mini" type="info" @click="addVersionRe">添加任务</el-button>
      </div>
      <el-table ref="tableData" :height="tableHeight" :data="tableData" stripe border
        header-cell-class-name="table_header">

        <!-- 序号 -->
        <el-table-column fixed="left" label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>

        <!-- 任务编码 -->
        <el-table-column fixed="left" prop="taskCode" label="任务编码" header-align="center" width="120" align="left">
          <template slot-scope="scope">
            <div style="display: flex" v-if="scope.row.isEdit">
              <el-input size="mini" type="text" :maxlength="8" placeholder="请输入" v-model.trim="scope.row.taskCode">
              </el-input>
            </div>
            <div v-else>
              {{ scope.row.taskCode || '-' }}
            </div>
          </template>
        </el-table-column>
             <!-- 任务名称 -->
        <el-table-column show-overflow-tooltip fixed="left" prop="taskContentName" label="任务名称" width="200"
          header-align="center" align="left">
          <template slot-scope="scope">
            <el-select v-if="scope.row.isEdit" style="padding:4px 0;" size="mini" filterable
              v-model="scope.row.taskContentName" placeholder="请选择"
              @change="handleSelectContentName(scope.row, scope.$index)">
              <el-option v-for="(item, index) in taskContentList" :key="index" :label="item.taskContentName"
                :value="item.taskContentName"></el-option>
            </el-select>
            <div v-else>
              {{ scope.row.taskContentName || '-' }}
            </div>
          </template>

        </el-table-column>

        <!-- 任务分类 -->
        <el-table-column show-overflow-tooltip  prop="taskCategory" label="任务分类" width="180"
          header-align="center" align="left">
          <template slot-scope="scope">
            <el-select v-if="scope.row.isEdit" size="mini" multiple v-model="scope.row.taskCategory" filterable
              placeholder="请选择">
              <el-option v-for="item in getCodeListByKey('任务分类')" :key="item.value" :label="item.text"
                :value="item.value"></el-option>
            </el-select>
            <div v-else>
              {{ codeTransformLable(scope.row.taskCategory, getCodeListByKey('任务分类')) }}
            </div>
          </template>

        </el-table-column>

   

        <!-- 终端类型分类 -->
        <el-table-column show-overflow-tooltip prop="terminalTypeClassificationJson" label="终端类型分类" width="180" header-align="center"
          align="left">
          <template slot-scope="scope">
            <el-select v-if="scope.row.isEdit" size="mini" multiple v-model="scope.row.terminalTypeClassificationJson" filterable
              placeholder="请选择">
              <el-option v-for="item in getCodeListByKey('终端类型分类')" :key="item.value" :label="item.text"
                :value="item.value"></el-option>
            </el-select>
            <div v-else>
              {{ codeTransformLable(scope.row.terminalTypeClassificationJson, getCodeListByKey('终端类型分类')) }}
            </div>
          </template>

        </el-table-column>


        <!-- 对应产品类别 -->
        <el-table-column show-overflow-tooltip prop="goodsCategoryJson" label="产品类别" width="180" header-align="center"
          align="left">
          <template slot-scope="scope">
            <el-select v-if="scope.row.isEdit" size="mini" multiple v-model="scope.row.goodsCategoryJson" filterable
              placeholder="请选择">
              <el-option v-for="item in getCodeListByKey('超级模版-对应产品类别')" :key="item.value" :label="item.text"
                :value="item.value"></el-option>
            </el-select>
            <div v-else>
              {{ codeTransformLable(scope.row.goodsCategoryJson, getCodeListByKey('超级模版-对应产品类别')) }}
            </div>
          </template>

        </el-table-column>

        <!-- 任务大类 -->
        <el-table-column show-overflow-tooltip prop="taskType" label="任务大类" width="120" header-align="center"
          align="left">
          <template slot-scope="scope">
            <el-select v-if="scope.row.isEdit" size="mini" filterable v-model="scope.row.taskType" placeholder="请选择">
              <el-option v-for="(item, index) in taskTypeList" :key="index" :label="item.paramName"
                :value="item.paramName"></el-option>
            </el-select>
            <div v-else>
              {{ scope.row.taskType }}
            </div>
          </template>
        </el-table-column>

        <!-- 任务中类 -->
        <el-table-column show-overflow-tooltip prop="taskMediumType" label="任务中类" width="120" header-align="center"
          align="left">
          <template slot-scope="scope">
            <el-select v-if="scope.row.isEdit" size="mini" v-model="scope.row.taskMediumType" filterable
              placeholder="请选择">
              <el-option v-for="item in getCodeListByKey('超级模版-任务中类')" :key="item.value" :label="item.text"
                :value="item.value"></el-option>
            </el-select>
            <div v-else>
              {{ codeTransformLable(scope.row.taskMediumType, getCodeListByKey('超级模版-任务中类')) }}
            </div>
          </template>
        </el-table-column>

        <!--是否常规任务 -->
        <el-table-column prop="isNormalTask" label="是否常规任务" width="120" header-align="center" align="left">
          <template slot-scope="scope">
            <el-select v-if="scope.row.isEdit" size="mini" v-model="scope.row.isNormalTask" placeholder="请选择">
              <el-option v-for="(item, index) in [{ label: '是', value: 'Y' }, { label: '否', value: 'N' }]" :key="index"
                :label="item.label" :value="item.value"></el-option>
            </el-select>
            <div v-else>
              {{ scope.row.isNormalTask == 'Y' ? '是' : scope.row.isNormalTask == 'N' ? '否' : '-' }}
            </div>
          </template>
        </el-table-column>

        <!-- 分类对象 -->
        <el-table-column show-overflow-tooltip prop="staffCategoryJson" label="分类对象" width="200" header-align="center"
          align="left">
          <template slot-scope="scope">
            <el-select style="width:100%" v-if="scope.row.isEdit" size="mini" multiple
              v-model="scope.row.staffCategoryJson" filterable placeholder="请选择">
              <el-option v-for="item in getCodeListByKey('超级模版-对象分类')" :key="item.value" :label="item.text"
                :value="item.value"></el-option>
            </el-select>
            <div v-else>
              {{ codeTransformLable(scope.row.staffCategoryJson, getCodeListByKey('超级模版-对象分类')) }}
            </div>
          </template>
        </el-table-column>

        <!-- 市场分类 -->
        <el-table-column show-overflow-tooltip prop="marketingCategoryJson" label="市场分类" width="200"
          header-align="center" align="left">
          <template slot-scope="scope">
            <el-select v-if="scope.row.isEdit" size="mini" multiple v-model="scope.row.marketingCategoryJson" filterable
              placeholder="请选择">
              <el-option v-for="item in getCodeListByKey('超级模版-市场分类')" :key="item.value" :label="item.text"
                :value="item.value"></el-option>
            </el-select>
            <div v-else>
              {{ codeTransformLable(scope.row.marketingCategoryJson, getCodeListByKey('超级模版-市场分类')) }}
            </div>
          </template>
        </el-table-column>
        <!--启用状态 -->
        <el-table-column prop="bizState" label="启用状态" width="90" header-align="center" align="left">
          <template slot-scope="scope">
            <el-select v-if="scope.row.isEdit" size="mini" v-model="scope.row.bizState" placeholder="请选择">
              <el-option v-for="(item, index) in [{ label: '启用', value: 'Y' }, { label: '禁用', value: 'S' }]"
                :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <div v-else>
              {{ scope.row.bizState == 'Y' ? '启用' : scope.row.bizState == 'S' ? '禁用' : '-' }}
            </div>
          </template>
        </el-table-column>



        <!-- 系统功能 -->
        <el-table-column prop="menuName" show-overflow-tooltip label="系统功能" header-align="center" width="150"
          align="left">
          <template slot-scope="scope">{{ scope.row.menuName || '-' }}{{ scope.row.menuRemark ? '（' +
            scope.row.menuRemark
            + '）' : ''
            }}</template>
        </el-table-column>

        <!-- 药企固定指导价 -->
        <el-table-column prop="tenantTaskPrice" label="药企固定指导价" header-align="center" width="120" align="right">
          <template slot-scope="scope">
            <div style="display: flex" v-if="scope.row.isEdit">
              <el-input oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
              size="mini" type="input" :maxlength="30" placeholder="请输入价格"
                v-model.trim="scope.row.tenantTaskPrice">
              </el-input>
            </div>
            <div v-else>
              {{ scope.row.tenantTaskPrice | numDigit }}
            </div>

          </template>
        </el-table-column>

        <!-- 业务员固定指导价 -->
        <el-table-column prop="taskPrice" label="业务员固定指导价" header-align="center" width="120" align="right">
          <template slot-scope="scope">
            <div style="display: flex" v-if="scope.row.isEdit">
              <el-input oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
              size="mini" type="input" :maxlength="30" placeholder="请输入价格" v-model.trim="scope.row.taskPrice">
              </el-input>
            </div>
            <div v-else>
              {{ scope.row.taskPrice | numDigit }}
            </div>
          </template>
        </el-table-column>

          <!-- 药企区间指导价 -->
          <el-table-column label="药企区间指导价" header-align="center" width="220" align="left">
          <template slot-scope="scope">
            <div v-if="scope.row.isEdit" style="display: flex">
              <el-input @input="scope.row.tenantMinPrice=scope.row.tenantMinPrice.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
              style="width: 100px; float: left; margin-right: 10px" size="mini" type="input" :maxlength="30"
                placeholder="请输入价格" v-model.trim="scope.row.tenantMinPrice">
              </el-input>

              <el-input  @input="scope.row.tenantMaxPrice=scope.row.tenantMaxPrice.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
              style="width: 100px; float: left;" size="mini" type="input" :maxlength="30" placeholder="请输入价格"
                v-model.trim="scope.row.tenantMaxPrice">
              </el-input>
            </div>
            <div v-else-if="!scope.row.isEdit && scope.row.tenantMaxPrice">
              {{ scope.row.tenantMinPrice | numDigit }} - {{ scope.row.tenantMaxPrice | numDigit }}
            </div>
            <div v-else>
              -
            </div>
          </template>
        </el-table-column>

        <!-- 业务员基础报价 -->
        <el-table-column prop="staffBasePrice" label="业务员基础报价" header-align="center" width="120" align="right">
          <template slot-scope="scope">
            <div style="display: flex" v-if="scope.row.isEdit">
              <el-input oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
              size="mini" type="input" :maxlength="30" placeholder="请输入价格"
                v-model.trim="scope.row.staffBasePrice">
              </el-input>
            </div>
            <div v-else-if="!scope.row.isEdit && scope.row.staffBasePrice!=null">
              {{ scope.row.staffBasePrice | numDigit }}
            </div>
            <div v-else>
              -
            </div>
          </template>
        </el-table-column>

          <!-- 系数 -->
        <el-table-column prop="ruleCoefficient" label="调研深度系数" header-align="center" width="100" align="left">
          <template slot-scope="scope">
            {{ scope.row.ruleCoefficient || '-' }}
          </template>
        </el-table-column>

        <!-- 收费单位 -->
        <el-table-column prop="taskPrice" label="收费单位" header-align="center" width="94" align="left">
          <template slot-scope="scope">
            <div style="display: flex" v-if="scope.row.isEdit">
              <el-select filterable size="mini" style="float: left;" v-model="scope.row.taskPriceUnitGuid"
                placeholder="单位" @change="handleSelecTaskPriceUnit(scope.row.taskPriceUnitGuid, 1, scope.$index)">
                <el-option v-for="(item, index) in  taskPriceUnitList " :key="index" :label="item.paramValue"
                  :value="item.guid">
                </el-option>
              </el-select>
            </div>
            <div v-else>
              {{ scope.row.taskPriceUnitGuid ? scope.row.taskPriceUnit : '-' }}
            </div>
          </template>
        </el-table-column>

        <!-- 计算方式 -->
        <el-table-column prop="calcType" label="计算方式" width="110" header-align="center" align="left">
          <template slot-scope="scope">
            <el-select v-if="scope.row.isEdit" size="mini" v-model="scope.row.calcType" placeholder="计算方式">
              <el-option v-for="(item, index) in calcTypeList" :key="index" :label="item" :value="item"></el-option>
            </el-select>
            <div v-else>
              {{ scope.row.calcType || '-' }}
            </div>
          </template>
        </el-table-column>

        <!--任务量单位  -->
        <el-table-column :render-header="renderHeader" prop="taskTotal" label="任务量单位" header-align="center" width="140"
          align="left">
          <template slot-scope="scope">
            <div v-if="scope.row.isEdit" style="display: flex;justify-content:center;">
              <el-select filterable size="mini" style="float: left" v-model="scope.row.taskTotalUnitGuid"
                @change="handleSelecTaskTotalUnit(scope.row.taskTotalUnitGuid, scope.$index)" placeholder="单位">
                <el-option v-for="(item, index) in taskTotalUnitList" :key="index"
                  :label="item.paramValue + '(' + item.paramValue1 + ')'" :value="item.guid"></el-option>
              </el-select>
            </div>
            <div v-else>
              {{ scope.row.taskTotalUnitGuid ? scope.row.taskTotalUnit : '-' }}
            </div>
          </template>
        </el-table-column>

        <!-- 打卡要求 -->
        <el-table-column prop="isAskClock" label="打卡要求" width="80" header-align="center" align="left">
          <template slot-scope="scope">
            <el-select v-if="scope.row.isEdit" size="mini" v-model="scope.row.isAskClock" placeholder="是否要求">
              <el-option v-for="(item, index) in ['是', '否']" :key="index" :label="item" :value="item"></el-option>
            </el-select>
            <div v-else>
              {{ scope.row.isAskClock || '-' }}
            </div>
          </template>
        </el-table-column>

        <!-- 拍照要求 -->
        <el-table-column label="拍照要求" header-align="center" width="220" align="left">
          <template slot-scope="scope">
            <div v-if="scope.row.isEdit" style="display: flex">
              <el-select size="mini" style="width: 100px; float: left; margin-right: 10px"
                v-model="scope.row.isAskPhoto" placeholder="是否要求">
                <el-option v-for="(item, index) in ['是', '否']" :key="index" :label="item" :value="item"></el-option>
              </el-select>
              <el-input size="mini" type="input" style="width: 100px; float: left" :maxlength="30" placeholder="至少几张"
                v-model="scope.row.minAskPhoto" oninput="value=value.replace(/[^\.\d]/g,'')">
              </el-input>
            </div>
            <div v-else>
              {{ scope.row.isAskPhoto == '是' ? '是，最少' + scope.row.minAskPhoto + '张' : scope.row.isAskPhoto == '否' ? '否'
              :
              '-'
              }}
            </div>
          </template>
        </el-table-column>

        <!-- 上传资料 -->
        <el-table-column label="上传资料" header-align="center" width="220" align="left">
          <template slot-scope="scope">
            <div v-if="scope.row.isEdit" style="display: flex">
              <el-select size="mini" style="width: 100px; float: left; margin-right: 10px"
                v-model="scope.row.isAskUpload" placeholder="是否要求">
                <el-option v-for="(item, index) in ['是', '否']" :key="index" :label="item" :value="item"></el-option>
              </el-select>
              <el-input size="mini" type="input" style="width: 100px; float: left" :maxlength="30" placeholder="至少几张"
                v-model="scope.row.minAskUpload" oninput="value=value.replace(/[^\.\d]/g,'')">
              </el-input>
            </div>
            <div v-else>
              {{ scope.row.isAskUpload == '是' ? '是，最少' + scope.row.minAskUpload + '张' : scope.row.isAskUpload == '否' ?
              '否' : '-' }}
            </div>
          </template>
        </el-table-column>

        <!-- 是否智能计算 -->
        <el-table-column prop="isAskClock" label="是否智能计算" width="100" header-align="center" align="left">
          <template slot-scope="scope">
            <el-select v-if="scope.row.isEdit && scope.row.taskType === '数据采集'" size="mini"
              v-model="scope.row.isSmartCalculate">
              <el-option v-for="(item) in getCodeListByKey('是否')" :key="item.value" :label="item.text"
                :value="item.value"></el-option>
            </el-select>
            <div v-else>
              {{ scope.row.isSmartCalculate | getIsInvoiceFirst }}
            </div>
          </template>
        </el-table-column>

        <!-- 界面排序 -->
        <el-table-column label="界面排序" header-align="center" width="100" align="left">
          <template slot-scope="scope">
            <div v-if="scope.row.isEdit" style="display: flex">
              <el-input size="mini" type="input" style="width: 100px; float: left" :maxlength="30" placeholder="请输入"
                v-model="scope.row.orderIndex" oninput="value=value.replace(/[^\d]/g,'')">
              </el-input>
            </div>
            <div v-else>
              {{ scope.row.orderIndex || '-' }}
            </div>
          </template>
        </el-table-column>

        <el-table-column min-width="240px" label="操作" header-align="center" align="center" fixed="right">
          <template slot-scope="scope">
            <a class="txt-color" v-if="scope.row.isEdit" @click="closeEdit(scope.$index)">取消 ｜</a>
            <a class="txt-color" @click="openEdit(scope.$index)">{{ !scope.row.isEdit ? '编辑' : '保存' }} ｜</a>
            <a class="txt-color" v-if="scope.row.guid" @click="openOrClose(scope.$index)">{{ scope.row.bizState == 'Y' ?
              '禁用' : '启用' }} ｜</a>
            <a class="txt-color" @click="editMoreVersion(scope.$index)">更多内容 ｜</a>
            <a class="txt-color" @click="delVersion(scope.$index)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 表单结束 -->
    <el-pagination class="pt pb back-color-fff content-pagination-box" background @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100, 200]" :current-page="page.pageIndex"
      :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
    </el-pagination>
    <!-- 完成更多 开始 -->
    <div v-if="!iconVisible" id="template-config">
      <el-dialog :title="textTitle" :visible.sync="dialogVisible" width="740px">
        <template v-if="dialogVisible">
          <el-form label-width="140px" :label-position="right" class="demo-ruleForm">
            <div class="calc-type">
              <el-form-item>
                <span slot="label" style="color: red">*</span>
                <span slot="label">任务结算规则</span>
                <div style="display:flex;flex-direction:column;text-align: left;">
                  <el-radio style="margin-bottom:10px;" v-model="tableData[currentIndex].settleRule"
                    label="1">按单价结算，完成量*单价结算</el-radio>
                  <el-radio v-model="tableData[currentIndex].settleRule" label="2">按比例结算，当任务量大于0时，按任务量的
                    <el-input class="task-precent" v-model="tableData[currentIndex].settlePercent"
                      oninput="value=value.replace(/[^\d]/g,'')" />%结算
                    <el-tooltip class="item" effect="dark"
                      content="例如：某个人发放 7 万元费用，比例配置为40%，只要有做此任务，那么结算金额最高为 2.8万元（7万 * 40%）" placement="right-start"><i
                        class="el-icon-question"></i></el-tooltip>
                  </el-radio>
                </div>
              </el-form-item>
            </div>

            <el-form-item>
              <span slot="label" style="color: red">*</span>
              <span slot="label">工作内容描述
              </span>
              <el-tooltip class="tips fl" effect="dark" content="手机端展示" placement="right-start"><i
                  class="el-icon-question"></i></el-tooltip>
              <div class="fl" style="width: 400px;">

                <el-input class="fl" style="width: 400px" type="textarea" :rows="5" :maxlength="200" placeholder="请输入"
                  v-model="tableData[currentIndex].staffTaskNote">
                </el-input>
              </div>
            </el-form-item>

            <el-form-item>
              <span slot="label" style="color: red">*</span>
              <span slot="label">工作内容明细

              </span>
              <el-tooltip class="tips fl" effect="dark" content="手机端、PC端详细展示" placement="right-start"><i
                  class="el-icon-question"></i></el-tooltip>
              <div class="fl" style="width: 400px">
                <el-input class="fl" type="textarea" :rows="5" :maxlength="200" placeholder="请输入"
                  v-model="tableData[currentIndex].tenantTaskNote">
                </el-input>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label" style="color: red">*</span>
              <span slot="label">任务管理要求

              </span>
              <el-tooltip class="tips fl" effect="dark" content="手机端展示给业务员看的工作要求" placement="right-start"><i
                  class="el-icon-question"></i></el-tooltip>
              <div class="fl" style="width: 400px">
                <el-input class="fl" type="textarea" :rows="7" :maxlength="400" placeholder="示例：
1、打卡：需要在客户所在位置定位，不能超出客户1公里范围内；
2、照片拍摄：1)门头照带自拍；2)与客户沟通照片或者客户内部照片；
3、系统录入：录入客户拜访其他新增事项；
4、文字编辑: 不得少于30字。" v-model="tableData[currentIndex].staffWorkNote">
                </el-input>
              </div>
            </el-form-item>
            <!-- <el-form-item>
              <span slot="label" style="color: red">*</span>
              <span slot="label">任务管理要求
              </span>
              <el-tooltip class="tips fl" effect="dark" content="手机端展示给业务员看的工作要求" placement="right-start"><i
                  class="el-icon-question"></i></el-tooltip>
                   <el-input class="fl" type="textarea" :rows="5" :maxlength="400"
                  placeholder="示例：（系统会自动根据行数增加序号;照片拍摄：门头照+行动轨迹或者门头自拍照或者加时间水印的内部照3选1；系统录入：录入竞品相关数据；文字编辑：不得少于50字"
                  v-model="tableData[currentIndex].staffWorkNote">
                </el-input>
            </el-form-item> -->


            <el-form-item>
              <span slot="label" style="color: red">*</span>
              <span slot="label">任务图标 </span>
              <el-tooltip class="tips fl" effect="dark" content="手机端展示的任务图标" placement="right-start"><i
                  class="el-icon-question"></i></el-tooltip>
              <div class="img-close"
                v-if="tableData[currentIndex].fileList && tableData[currentIndex].fileList.length != 0 && tableData[currentIndex].fileList[0].url">
                <img class="file-img" :src="tableData[currentIndex].fileList && tableData[currentIndex].fileList[0].url"
                  alt="" srcset="" />
                <img class="close" v-if="tableData[currentIndex].isEdit" @click="delPic"
                  src="@/assets/images/ic_close.png" alt="" />
              </div>
              <div class="icon-add" v-if="tableData[currentIndex].isEdit" @click="addPic"><i class="el-icon-plus"></i>
              </div>
            </el-form-item>
          </el-form>

          <span slot="footer" class="dialog-footer">
            <el-button size="mini" type="info" @click="dialogVisible = false">取 消</el-button>
            <el-button size="mini" v-if="tableData[currentIndex].isEdit" type="info" @click="moreSure">确 定</el-button>
          </span>
        </template>

      </el-dialog>
    </div>
    <!-- 完成更多 结束 -->

    <!-- 图标 开始 -->
    <el-dialog title="任务图标选择" class="icon-dialog-wrap" :visible.sync="iconVisible" width="50%">
      <div class="icon-dialog">
        <div class="icon-left">
          <div class="item" :style="activeIcon == index ? 'background:#EDEDED;' : ''" @click="handleClickMenu(index)"
            v-for="(item, index) in iconList" :key="index">
            {{ item.paramName }}
          </div>
        </div>
        <div class="icon-right">
          <div class="pic" v-for="(item, index) in iconList[activeIcon] &&
            iconList[activeIcon].paramValue &&
            JSON.parse(iconList[activeIcon].paramValue)" :key="index">
            <div class="img-wrap" @click="chooseIcon(item.url)">
              <el-image class="img" :src="item.url" fit="contain" />
              <img :style="chooseURL == item.url ? 'display:block' : 'display:none;'" class="border-img"
                src="@/assets/images/ic_select.png" alt="" />
              <div class="name">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="medium" type="info" @click="moreSureIcon">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 图标结束 -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      showMore: false, // 筛选项显示更多，默认否，最多显示三个
      tableHeight: window.innerHeight - 263,
      contentMainHeight: window.innerHeight - 200,
      superStateList: [{ label: '全部', value: null }, { label: '已启用', value: 'Y' }, { label: '已禁用', value: 'S' }],
      page: {
        isSuper: 'Y',
        bizState: null,//是否启用
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        taskCode: '', //任务编码
        taskContentName: [],//任务名称
        taskTypeGuid: '',//任务大类
        marketingCategoryJson: null,//市场分类
        staffCategoryJson: null,//分类对象
        goodsCategoryJson: null,//产品对象
        terminalTypeClassificationJson:null,//终端类型分类
        isSmartCalculate: null,//是否智能计算
        orderByRule: '7',//是否智能计算
      },
      serviceTenantGuid: '', //服务商id
      serviceTenantName: '', //服务商名称
      fullscreenLoading: false,
      textTitle: '新增任务大类',
      organisationList: [],
      tenantList: [],
      sendTenantList: [], //委托方
      taskTypeList: [],
      taskContentList: [],

      taskTotalUnitList: [],
      taskPriceUnitList: [],
      clientObjectList: [],
      clientObject: [],
      clientAreaList: [
        '北京',
        '天津',
        '上海',
        '重庆',
        '河北',
        '河南',
        '云南',
        '辽宁',
        '安徽',
        '山东',
        '新疆',
        '江苏',
        '浙江',
        '江西',
        '湖北',
        '广西',
        '甘肃',
        '山西',
        '内蒙古',
        '陕西',
        '吉林',
        '福建',
        '贵州',
        '广东',
        '青海',
        '西藏',
        '四川',
        '宁夏',
        '海南',
        '台湾',
        '黑龙江',
        '湖南',
      ],
      clientAreaRadio: '',
      clientArea: '',
      templateName: '',
      taskType: '',
      taskContentName: '',
      tenantName: '',
      taskTag: [],

      taskTotal: '',
      taskTotalUnit: '',
      taskTotalUnitGuid: '',

      taskPrice: '',
      taskPriceUnit: '',
      taskPriceUnitGuid: '',

      tenantTaskPrice: '', //药企固定指导价
      tenantTaskPriceUnit: '',
      tenantTaskPriceUnitGuid: '',

      staffBasePrice:'',
      tenantMinPrice:'',
      tenantMaxPrice:'',

      taskNote: '',
      height: window.innerHeight - 260,
      right: 'right',
      tableData: [],
      dialogVisible: false,

      visible3: false,
      area: [],
      departmentList: [],
      departmentData: '',
      areaData: [],
      delList: [],
      filterText: '',

      visible2: false,
      multipleSelection: [],

      loading: false,
      provinceArray: [
        { name: '北京', code: 110000 },
        { name: '天津', code: 120000 },
        { name: '河北', code: 130000 },
        { name: '山西', code: 140000 },
        { name: '内蒙古', code: 150000 },
        { name: '辽宁', code: 210000 },
        { name: '吉林', code: 220000 },
        { name: '黑龙江', code: 230000 },
        { name: '上海', code: 310000 },
        { name: '江苏', code: 320000 },
        { name: '浙江', code: 330000 },
        { name: '安徽', code: 340000 },
        { name: '福建', code: 350000 },
        { name: '江西', code: 360000 },
        { name: '山东', code: 370000 },
        { name: '河南', code: 410000 },
        { name: '湖北', code: 420000 },
        { name: '湖南', code: 430000 },
        { name: '广东', code: 440000 },
        { name: '广西', code: 450000 },
        { name: '海南', code: 460000 },
        { name: '重庆', code: 500000 },
        { name: '四川', code: 510000 },
        { name: '贵州', code: 520000 },
        { name: '云南', code: 530000 },
        { name: '西藏', code: 540000 },
        { name: '陕西', code: 610000 },
        { name: '甘肃', code: 620000 },
        { name: '青海', code: 630000 },
        { name: '宁夏', code: 640000 },
        { name: '新疆', code: 650000 },
      ],
      currentIndex: 0, //当前操作行
      calcTypeList: ['系统计算', '固定量人均', '按学术活动计划', '不限量'],
      detail: null,
      iconVisible: false,
      iconList: [],
      activeIcon: 0,
      chooseURL: null,
      allTempList:[],
      sortOptions:[
        {name:'大类与编码组合正序',value:'7'},
        {name:'大类与编码组合倒序',value:'8'},
        {name:'创建时间正序',value:'1'},
        {name:'创建时间倒序',value:'2'},
        {name:'更新时间正序',value:'3'},
        {name:'更新时间倒序',value:'4'},
        {name:'界面排序正序',value:'5'},
        {name:'界面排序倒序',value:'6'},
      ]
    };
  },
  created() {
    let userInfo = JSON.parse(localStorage.userInfo);
    this.serviceTenantName = userInfo.tenantName;
    this.serviceTenantGuid = localStorage.guid;
    // this.getTenantList();
    // this.getSendTenantList();
    this.getTaskTypeList();
    this.getTaskContentList();
    this.getTaskTotalUnitList();
    this.getTaskPriceUnitList();
    this.getIconList();
    this.getList();
    // this.getAllTempList()
  },
  computed: {
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    showMore(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 330;
        this.contentMainHeight = window.innerHeight - 232;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 263;
        this.contentMainHeight = window.innerHeight - 200;
        return;
      }
    },
  },
  methods: {
    renderHeader: function (h, { column, $index }) {
      return [
        column.label,
        h(
          'el-tooltip',
          {
            props: {
              placement: 'top',
              effect: 'dark',
              //content:"提示框内容",//如果提示内容短不需要换行，直接使用这个提示内容
            },
          },
          [
            h(
              'div',
              {
                //当前div是为了实现换行，就这换行研究了好久。。。
                slot: 'content',
              },
              [
              '用于统计任务以何种规则计算任务完成值'
              ],
            ),
            h('span', {
              //问号模块
              class: {
                'el-icon-question': true,
              },
            }),
          ],
        ),
      ];
    },
    codeTransformLable(val, list) {
      if (!val || !val.length) return '-';
      let result = [];
      if (typeof val == 'string') {
        list.forEach(item => {
          if (item.value == val) {
            result.push(item.text);
          }
        })
      } else {
        list.forEach(item => {
          val.forEach(el => {
            if (el == item.value) {
              result.push(item.text);
            }
          })
        })
      }
      return result.join('、');
    },
    handleSelecTaskPriceUnit(value, state, index) {
      let taskPriceUnitList = this.taskPriceUnitList;
      let labelItem = taskPriceUnitList.filter(item => item.guid == value)
      this.tableData[index].tenantTaskPriceUnitGuid = value;
      this.tableData[index].taskPriceUnit = labelItem[0].paramValue;
      this.tableData[index].tenantTaskPriceUnit = labelItem[0].paramValue;
    },
    handleSelecTaskTotalUnit(value, index) {
      let taskTotalUnitList = this.taskTotalUnitList;
      let labelItem = taskTotalUnitList.filter(item => item.guid == value)
      console.log(labelItem)
      this.tableData[index].taskTotalUnit = labelItem[0].paramValue;
    },

    searchData() {
      this.page.pageIndex = 1;
      // this.page.pageSize = 10;
      this.page.totalPage = 0;
      this.page.totalRows = 0;
      this.tableData = [];
      this.getList();
    },
    emptySearch(flag) {
      this.page = {
        isSuper: 'Y',
        bizState: null,//是否启用
        pageIndex: 1,
        pageSize: this.page.pageSize,
        totalPage: 0,
        totalRows: 0,
        taskCode: '', //任务编码
        taskContentName: null,//任务名称
        taskTypeGuid: '',//任务大类
        marketingCategoryJson: null,//市场分类
        staffCategoryJson: null,//分类对象
        goodsCategoryJson: null,//产品对象
        terminalTypeClassificationJson:null,//终端类型分类
        isSmartCalculate: null,//是否智能计算
        orderByRule: '7',//是否智能计算
      };
      this.getList();
    },
    moreSure() {
      var index = this.currentIndex;
      var tableData = this.tableData;
      if (tableData[index].settleRule == 2 && !tableData[index].settlePercent) {
        this.$message.error('请输入结算比例');
        return;
      }
      if (!tableData[index].tenantTaskNote) {
        this.$message.error('请填写工作内容描述');
        return;
      }
      if (!tableData[index].staffTaskNote) {
        this.$message.error('请填写工作内容明细');
        return;
      }
      if (tableData[index].fileList.length == 0) {
        this.$message.error('请上传任务图标');
        return;
      }
      this.dialogVisible = false;
    },
    getList(flag) {
      let self = this;
      let req = this.page;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/template/detail/get-detail-page-list`, req).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let tableData = res.data.data ? res.data.data.records : [];
          if (!tableData || !tableData.length) return;
          let newTableData = [];
          this.page.totalPage = res.data.data.totalPages;
          this.page.totalRows = res.data.data.totalRows;

          tableData.forEach((el, ky) => {
            var tableItem = {
              isEdit: false,
              guid: '',
              departmentData: [], //部门
              taskType: '', //任务大类
              taskContentName: '', //任务名称
              taskContentList: [], //任务名称list
              menuUrl: '', // 系统功能路径
              taskContentJson: null,
              menuName: '', //系统功能

              taskTotal: '',
              taskTotalUnit: '',
              taskTotalUnitGuid: '',

              taskPrice: '', //任务价格
              taskPriceUnit: '',
              taskPriceUnitGuid: '',

              tenantTaskPrice: '',
              tenantTaskPriceUnit: '',
              tenantTaskPriceUnitGuid: '',

              staffBasePrice:'',
              tenantMinPrice:'',
              tenantMaxPrice:'',

              settleRule: '1',
              settlePercent: null,

              isAskClock: '', //是否要求打卡 是/否

              isAskPhoto: '', //是否要求拍照 是/否
              minAskPhoto: '', //最少要求拍照数量

              isAskUpload: '', //是否要求上传资料 是/否
              minAskUpload: '', //最少上传资料数量
              taskTotal: '',
              taskTotalUnit: '',
              taskTag: '', //任务要求
              multipleSelection: [], //品种
              calcType: '系统计算',
              tenantWorkNote: '', //药企工作要求
              tenantTaskNote: '', //药企任务文案
              staffWorkNote: '', //运营工作要求
              staffTaskNote: '', //运营任务文案
              clientAreaRadio: '不限区域',
              clientArea: [],
              fileList: [],
              isTeamLeader: '',
              isAllowTenantUse: '',
              menuRemark: '',

              taskCode: '',//任务编码
              taskCategory: [],//任务分类
              goodsCategoryJson: [],//产品分类
              terminalTypeClassificationJson:[],//终端类型分类
              marketingCategoryJson: [],//市场分类
              staffCategoryJson: [],//分类对象
              taskMediumType: '',//任务中类
              bizState: '',//启用状态
              isNormalTask: '',//是否常规任务
              orderIndex: '',//界面排序

            };
            tableItem.guid = el.guid
            tableItem.isAllowTenantUse = el.isAllowTenantUse
            tableItem.isTeamLeader = el.isTeamLeader;
            tableItem.menuRemark = el.menuRemark;


            tableItem.taskCode = el.taskCode;
            tableItem.taskCategory = el.taskCategory ? JSON.parse(el.taskCategory) : null;
            tableItem.terminalTypeClassificationJson = el.terminalTypeClassificationJson ? JSON.parse(el.terminalTypeClassificationJson) : null;

            tableItem.goodsCategoryJson = el.goodsCategoryJson ? JSON.parse(el.goodsCategoryJson) : null;
            tableItem.marketingCategoryJson = el.marketingCategoryJson ? JSON.parse(el.marketingCategoryJson) : null;
            tableItem.staffCategoryJson = el.staffCategoryJson ? JSON.parse(el.staffCategoryJson) : null;
            tableItem.taskMediumType = el.taskMediumType;
            tableItem.bizState = el.bizState;
            tableItem.isNormalTask = el.isNormalTask;
            tableItem.orderIndex = el.orderIndex;

            //部门
            var departmentData = [];
            var organisationInfo = JSON.parse(el.organisationInfo);
            organisationInfo.forEach((item) => {
              if (item.guid) {
                departmentData.push({
                  guid: item.guid,
                  organisationName: item.name,
                });
              }
            });
            tableItem.departmentData = departmentData;

            //任务大类
            tableItem.taskType = el.taskType;
            tableItem.taskContentList = [];

            //任务名称
            tableItem.taskContentName = el.taskContentName;
            tableItem.taskContentGuid = el.taskContentGuid
            tableItem.menuUrl = el.menuUrl;
            tableItem.taskContentJson = el.taskContentJson || null;
            tableItem.clientObject = el.clientObject;
            tableItem.menuName = el.menuName;


            //计算方式
            tableItem.calcType = el.taskTotalType;

            //药企价格
            tableItem.tenantTaskPrice = el.tenantTaskPrice;
            tableItem.tenantTaskPriceUnit = el.tenantTaskPriceUnit;
            tableItem.tenantTaskPriceUnitGuid = el.tenantTaskPriceUnitGuid;

            //业务员价格
            tableItem.taskPrice = el.taskPrice;
            tableItem.taskPriceUnit = el.taskPriceUnit;
            tableItem.taskPriceUnitGuid = el.taskPriceUnitGuid;


            tableItem.staffBasePrice = el.staffBasePrice;
            tableItem.tenantMinPrice = el.tenantMinPrice;
            tableItem.tenantMaxPrice = el.tenantMaxPrice;

            tableItem.ruleCoefficient = el.ruleCoefficient;



            //比例
            tableItem.settleRule = el.settleRule;
            tableItem.settlePercent = el.settlePercent;

            //是否要求打卡
            tableItem.isAskClock = el.isAskClock;

            //是否要求拍照
            tableItem.isAskPhoto = el.isAskPhoto;

            //最少要求拍照数量
            tableItem.minAskPhoto = el.minAskPhoto;

            //是否要求上传资料
            tableItem.isAskUpload = el.isAskUpload;

            //最少上传资料数量
            tableItem.minAskUpload = el.minAskUpload;

            //任务量设置
            tableItem.taskTotal = el.taskTotal;
            tableItem.taskTotalUnit = el.taskTotalUnit;
            tableItem.taskTotalUnitGuid = el.taskTotalUnitGuid;

            //药企任务文案 、药企工作要求 运营任务文案 运营工作文案
            tableItem.staffWorkNote = el.staffWorkNote.indexOf('[') > -1 ? JSON.parse(el.staffWorkNote).join('\n') : el.staffWorkNote;
            tableItem.staffTaskNote = el.staffTaskNote;
            tableItem.tenantWorkNote = el.tenantWorkNote;
            tableItem.tenantTaskNote = el.tenantTaskNote;

            //图标
            tableItem.fileList = JSON.parse(el.taskIcon);

            //任务要求
            tableItem.taskTag = el.taskTag ? JSON.parse(el.taskTag) : null;

            // 智能计算
            tableItem.isSmartCalculate = el.isSmartCalculate
            newTableData.push(tableItem);
          });
          this.tableData = newTableData;
          if (flag) {
            this.addNewItem();
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },

    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
    addVersionRe() {
      try {
        this.tableData.forEach((i, j) => {
          if (i.isEdit) {
            throw new Error('请先保存正在编辑中的模板，再新增其他模板！');
          }
        })
      } catch (e) {
        this.$message.error(e.message);
        return;
      }
      // this.emptySearch(true);
      this.getList(true);
     
    },
    addNewItem(){
      this.tableData.unshift({
        guid: null,
        departmentData: [], //部门
        taskType: '', //任务大类
        taskContentName: '', //任务名称
        // taskContentList: [], //任务名称list
        menuUrl: '', // 系统功能路径
        menuName: '', //系统功能
        taskContentJson: null,
        clientObject: '',
        taskPrice: '', //任务价格
        taskPriceUnit: '',
        taskPriceUnitGuid: '',

        tenantTaskPrice: '',
        tenantTaskPriceUnit: '',
        tenantTaskPriceUnitGuid: '',

        taskTotal: '',
        taskTotalUnit: '',
        taskTotalUnitGuid: '',

        staffBasePrice:'',
        tenantMinPrice:'',
        tenantMaxPrice:'',

        settleRule: '1',
        settlePercent: null,
        isAskClock: '', //是否要求打卡 是/否
        isAskPhoto: '', //是否要求拍照 是/否
        minAskPhoto: '', //最少要求拍照数量
        isAskUpload: '', //是否要求上传资料 是/否
        minAskUpload: '', //最少上传资料数量

        taskTag: '', //任务要求
        multipleSelection: [], //品种
        calcType: '系统计算',
        tenantWorkNote: '', //药企工作要求
        tenantTaskNote: '', //药企任务文案
        staffWorkNote: '', //运营工作要求
        staffTaskNote: '', //运营任务文案
        clientAreaRadio: '不限区域',
        clientArea: '',
        fileList: [],
        taskCode: '',//任务编码
        taskCategory: [],//任务分类
        goodsCategoryJson: [],//产品分类
        terminalTypeClassificationJson:[],//终端类型分类
        marketingCategoryJson: [],//市场分类
        staffCategoryJson: [],//分类对象
        taskMediumType: '',//任务中类
        bizState: '',//启用状态
        isNormalTask: '',//是否常规任务
        isEdit: true
      });
      this.$nextTick(() => {
        this.$refs.tableData.bodyWrapper.scrollTop = this.$refs.tableData.bodyWrapper.scrollHeight
      })
    },
    getTaskTypeList() {
      let req = {
        pageIndex: 1,
        pageSize: -1,
        bizType: '任务大类',
        tenantGuid: localStorage.guid,
      };
      let self = this;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/get-list`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.taskTypeList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getTaskContentList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        // taskType: taskType,
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task-set/content/get-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.taskContentList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    // getTaskReqList(paramValue1, currentIndex, flag) {
    //   let self = this;
    //   let req = {
    //     pageIndex: 1,
    //     pageSize: -1,
    //     bizType: '工作要求',
    //     tenantGuid: localStorage.guid,
    //     paramValue1
    //   };
    //   if (!paramValue1) return;
    //   self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/get-list`, req).then((res) => {
    //     if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
    //       self.tableData[currentIndex].taskReqList = res.data.data.records;
    //       if (!flag) return;
    //       this.dialogVisible = true;
    //     } else {
    //       self.$message.error(res.data.msg);
    //     }
    //   });
    // },
    getTaskTotalUnitList() {
      let self = this;
      let req = {
        pageIndex: 1,
        pageSize: -1,
        bizType: '任务单位',
        paramName: '任务总量单位', //单位类型
        tenantGuid: localStorage.guid,
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/get-list`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.taskTotalUnitList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getTaskPriceUnitList() {
      let self = this;
      let req = {
        pageIndex: 1,
        pageSize: -1,
        bizType: '任务单位',
        paramName: '任务价格单位', //单位类型
        tenantGuid: localStorage.guid,
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/get-list`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.taskPriceUnitList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },

    handleSelectContentName(row, currentIndex) {

      var taskContentList = this.taskContentList;
      var taskContentName = row.taskContentName;
      taskContentList.forEach((item) => {
        if (item.taskContentName == taskContentName) {
          this.tableData[currentIndex].menuName = item.menuName;
          this.tableData[currentIndex].menuUrl = item.menuUrl;
          this.tableData[currentIndex].taskContentJson = {
            cityLevel: item.cityLevel,
            medLevel: item.medLevel,
            orgGrade: item.orgGrade,
            isRemote: item.isRemote,
            meetingType: item.meetingType,
            isCompetitor: item.isCompetitor,
            distributionArea: item.distributionArea,
            customerTypeJson: item.customerTypeJson,
            workContentJson: item.workContentJson,
            deviceCategory: item.deviceCategory,//器械分类 
          }
          this.tableData[currentIndex].taskContentName = item.taskContentName;
          this.tableData[currentIndex].taskContentGuid = item.guid;
          this.tableData[currentIndex].clientObject = item.clientObject;
          this.tableData[currentIndex].menuRemark = item.menuRemark;
          this.tableData[currentIndex].isTeamLeader = item.isTeamLeader;
          this.tableData[currentIndex].isAllowTenantUse = item.isAllowTenantUse;
         // this.getTaskReqList(item.guid, currentIndex, false);
        }
      });
    },
    delVersion(index) {
      if (this.tableData[index].guid) {
        //删除已有的
        this.fullscreenLoading = true;
        this.$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.fullscreenLoading = true;
            this.api.postJson(`/${serverConfig.msSalesPerformService}/template/detail/delete?guid=${this.tableData[index].guid}`).then((res) => {
              this.fullscreenLoading = false;
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                this.$message.success('删除成功');
                this.getList();
              } else {
                this.$message.error(res.data.msg);
              }
            });
          })
      } else {
        //删除新增的
        this.tableData.splice(index, 1);
      }
    },
    //更多内容编辑
    editMoreVersion(index) {
      this.textTitle = this.tableData[index].taskContentName
        ? `【${this.tableData[index].taskContentName}】编辑`
        : '任务名称编辑';
      this.currentIndex = index;
      this.dialogVisible = true;
     // this.getTaskReqList(this.tableData[index].taskContentGuid, index, true);
    },
    //开启编辑，保存
    openEdit(index) {
      if (this.tableData[index].isEdit) {
        //保存
        this.saveSuperTemplate(index);
      } else {
        //开启
        try {
          this.tableData.forEach((i, j) => {
            if (i.isEdit) {
              throw new Error('请先保存正在编辑中的模板，再编辑其他模板！');
            }
          })
        } catch (e) {
          this.$message.error(e.message);
          return;
        }
        this.tableData[index].isEdit = !this.tableData[index].isEdit;
        this.$forceUpdate();
      }
    },
    //取消
    closeEdit(index) {
      this.tableData[index].isEdit = !this.tableData[index].isEdit;
      this.getList();
    },
    saveSuperTemplate(index) {
      var self = this;
      var tableData = [this.tableData[index]];
      var detailList = [];
      try {
        tableData.forEach((el, orderIndex) => {
          var detail = {
            guid: '',
            taskContentName: '', //任务名称名称
            taskContentGuid: '', //任务名称GUID
            taskContentType: '', //任务名称类别
            taskType: '', //任务大类
            taskTypeGuid: '', //任务大类Guid

            tenantTaskPrice: '', //药企价格
            tenantTaskPriceUnit: '',
            tenantTaskPriceUnitGuid: '',

            menuUrl: '', //菜单地址
            taskContentJson: null,
            menuName: '', //菜单名称
            taskTotalType: '', //任务总量类型

            taskTotal: '', //任务总量
            taskTotalUnit: '', //任务总量单位
            taskTotalUnitGuid: '',

            taskPrice: '', //业务员固定指导价
            taskPriceUnit: '', //业务员固定指导价单位
            taskPriceUnitGuid: '',

            staffBasePrice:'',
            tenantMinPrice:'',
            tenantMaxPrice:'',



            staffWorkNote: '', //业务员工作要求
            staffTaskNote: '', //业务员任务文案
            tenantWorkNote: '', //药企工作要求
            tenantTaskNote: '', //药企任务文案
            countRule: '', //统计规则
            organisationInfo: null, //下发部门json
            taskIcon: '', //	string任务图标json
            isAskClock: '', //是否要求打卡 是/否
            isAskPhoto: '', //是否要求拍照 是/否
            minAskPhoto: '', //最少要求拍照数量
            isAskUpload: '', //是否要求上传资料 是/否
            minAskUpload: '', //最少上传资料数量
            // orderIndex: orderIndex + 1,
            orderIndex: '',
            isTeamLeader: '',
            menuRemark: '',
            isAllowTenantUse: '',
            clientAreaRadio: '不限区域',

            taskCode: '',//任务编码
            taskCategory: [],//任务分类
            goodsCategoryJson: [],//产品分类
            terminalTypeClassificationJson:[],//终端类型分类
            marketingCategoryJson: [],//市场分类
            staffCategoryJson: [],//分类对象
            taskMediumType: '',//任务中类
            bizState: '',//启用状态
            isNormalTask: ''//是否常规任务
          };
          detail.guid = el.guid || null;
          detail.isAllowTenantUse = el.isAllowTenantUse;

          detail.isTeamLeader = el.isTeamLeader;
          detail.menuRemark = el.menuRemark;

          //任务大类
          detail.taskType = el.taskType;
          this.taskTypeList.forEach((item) => {
            if (item.paramName == el.taskType) {
              detail.taskTypeGuid = item.guid;
            }
          });


          //任务名称
          this.taskContentList.forEach((item) => {
            if (item.taskContentName == el.taskContentName) {
              detail.taskContentGuid = item.guid;
              detail.menuUrl = item.menuUrl;
              detail.taskContentJson = JSON.stringify({
                cityLevel: item.cityLevel,
                medLevel: item.medLevel,
                orgGrade: item.orgGrade,
                isRemote: item.isRemote,
                meetingType: item.meetingType,
                isCompetitor: item.isCompetitor,
                distributionArea: item.distributionArea,
                customerTypeJson: item.customerTypeJson,
                workContentJson: item.workContentJson,
                deviceCategory: item.deviceCategory,//器械分类
              })
              detail.menuName = item.menuName;
              detail.clientObject = item.clientObject;
              detail.taskContentType = item.taskContentType;
              detail.taskContentName = item.taskContentName;
            }
          });
          //任务编码 、对应产品类别等
          detail.taskCode = el.taskCode;
          detail.taskCategory = el.taskCategory && el.taskCategory.length ? JSON.stringify(el.taskCategory) : null;
          detail.goodsCategoryJson = el.goodsCategoryJson && el.goodsCategoryJson.length ? JSON.stringify(el.goodsCategoryJson) : null;
          detail.terminalTypeClassificationJson = el.terminalTypeClassificationJson && el.terminalTypeClassificationJson.length ? JSON.stringify(el.terminalTypeClassificationJson) : null;

          detail.marketingCategoryJson = el.marketingCategoryJson && el.marketingCategoryJson.length ? JSON.stringify(el.marketingCategoryJson) : null;
          detail.staffCategoryJson = el.staffCategoryJson && el.staffCategoryJson.length ? JSON.stringify(el.staffCategoryJson) : null;
          detail.taskMediumType = el.taskMediumType;
          detail.bizState = el.bizState;
          detail.isNormalTask = el.isNormalTask;
          detail.orderIndex = el.orderIndex;

          if (!el.taskCode) {
            throw new Error('请填写任务编码');
          }
          if (/[\u4e00-\u9fa5/\s+/]|[^a-zA-Z0-9\u4E00-\u9FA5]/.test(el.taskCode)) {
            throw new Error('请填写正确的任务编码，任务编码仅能输入数字和字母');
          }
          if (!el.taskContentName) {
            throw new Error('请选择任务名称');
          }
          if (!el.goodsCategoryJson || !el.goodsCategoryJson.length) {
            throw new Error('请填写产品类别');
          }
          if (!el.taskType) {
            throw new Error('请选择任务大类');
          }
          if (!el.taskMediumType) {
            throw new Error('请选择任务中类');
          }
          if (!el.isNormalTask) {
            throw new Error('请选择是否常规任务');
          }
          if (!el.staffCategoryJson || !el.staffCategoryJson.length) {
            throw new Error('请选择分类对象');
          }
          if (!el.marketingCategoryJson || !el.marketingCategoryJson.length) {
            throw new Error('请选择市场分类');
          }
          if (!el.bizState) {
            throw new Error('请选择启用状态');
          }
          if (!el.taskPrice && !el.tenantTaskPrice && !el.tenantMinPrice && !el.tenantMaxPrice && !el.staffBasePrice) {
            throw new Error('药企、业务员的区间价和固定价两组必须至少填写一组');
          }
          if ((!el.taskPrice || !el.tenantTaskPrice) && !(el.tenantMinPrice && el.tenantMaxPrice && el.staffBasePrice)) {
            throw new Error('药企、业务员的区间价和固定价两组必须至少填写一组');
          }

          if (!(el.taskPrice && el.tenantTaskPrice) && (!el.tenantMinPrice || !el.tenantMaxPrice || !el.staffBasePrice)) {
            throw new Error('药企、业务员的区间价和固定价两组必须至少填写一组');
          }
   
          if (el.tenantTaskPrice && !/^(?:\d{1,3}(?:,\d{3})+|\d+)(?:\.\d{1,2})?$/.test(el.tenantTaskPrice)) {
            throw new Error('请填写正确的药企固定指导价');
          }
          if (el.tenantMinPrice && !/^(?:\d{1,3}(?:,\d{3})+|\d+)(?:\.\d{1,2})?$/.test(el.tenantMinPrice)) {
            throw new Error('请填写正确的药企区间指导价');
          }
          if (el.tenantMaxPrice && !/^(?:\d{1,3}(?:,\d{3})+|\d+)(?:\.\d{1,2})?$/.test(el.tenantMaxPrice)) {
            throw new Error('请填写正确的药企区间指导价');
          }
          if (el.taskPrice && !/^(?:\d{1,3}(?:,\d{3})+|\d+)(?:\.\d{1,2})?$/.test(el.taskPrice)) {
            throw new Error('请填写正确的业务员固定指导价');
          }
          console.log(el.tenantMinPrice)
          console.log(el.tenantMaxPrice)
          if (el.tenantMaxPrice && (+el.tenantMinPrice >= +el.tenantMaxPrice)) {
            throw new Error('药企区间最高价需大于最低价');
          }
          if (el.staffBasePrice && (+el.tenantMinPrice <= +el.staffBasePrice)) {
            throw new Error('业务员基础报价需小于药企区间最低价');
          }
          if (!el.taskPriceUnitGuid) {
            throw new Error('请填写收费单位');
          }
          detail.taskPrice = el.taskPrice;
          detail.tenantTaskPrice = el.tenantTaskPrice;
          detail.taskPriceUnit = el.taskPriceUnit;
          detail.taskPriceUnitGuid = el.taskPriceUnitGuid;
          detail.tenantTaskPriceUnit = el.tenantTaskPriceUnit;
          detail.tenantTaskPriceUnitGuid = el.tenantTaskPriceUnitGuid;

          detail.staffBasePrice = el.staffBasePrice;
          detail.tenantMinPrice = +el.tenantMinPrice;
          detail.tenantMaxPrice = +el.tenantMaxPrice;


          //标准量、标准量单位
          if (!el.taskTotalUnitGuid) {
            throw new Error('请选择任务量单位');
          }
          detail.taskTotal = null;
          detail.taskTotalUnit = el.taskTotalUnit;
          detail.taskTotalUnitGuid = el.taskTotalUnitGuid;

          if (!el.isAskClock) {
            throw new Error('请选择打卡要求');
          }
          detail.isAskClock = el.isAskClock;


          if (!el.isAskPhoto) {
            throw new Error('请选择拍照要求');
          }
          detail.isAskPhoto = el.isAskPhoto;

          if (!el.minAskPhoto && el.isAskPhoto == '是') {
            throw new Error('请填写最少拍照数量');
          }
          detail.minAskPhoto = el.minAskPhoto;

          if (!el.isAskUpload) {
            throw new Error('请选择上传资料要求');
          }
          detail.isAskUpload = el.isAskUpload;

          if (!el.minAskUpload && el.isAskUpload == '是') {
            throw new Error('请填写最少上传资料数');
          }
          detail.minAskUpload = el.minAskUpload;

          detail.settleRule = el.settleRule;
          detail.settlePercent = el.settleRule == 2 ? +el.settlePercent : null;

          //药企任务文案 、药企工作要求 运营任务文案 运营工作文案
          detail.staffWorkNote = JSON.stringify(el.staffWorkNote.split('\n'));
          detail.staffTaskNote = el.staffTaskNote;
          detail.tenantWorkNote = el.tenantWorkNote;
          detail.tenantTaskNote = el.tenantTaskNote;
          if (!el.tenantTaskNote) {
            throw new Error('请至【更多内容】中填写工作内容描述');
          }
          if (!el.staffTaskNote) {
            throw new Error('请至【更多内容】中填写工作内容明细');
          }
          if (!el.staffWorkNote) {
            throw new Error('请至【更多内容】中填写任务管理要求');
          }

          //任务图标
          detail.taskIcon = JSON.stringify(el.fileList);
          if (el.fileList && el.fileList.length == 0) {
            throw new Error('请至【更多内容】中上传任务图标');
          }

          //规则
          self.taskTotalUnitList.forEach((item) => {
            if (item.guid == el.taskTotalUnitGuid) {
              detail.countRule = item.paramValue1;
            }
          });

          

          //任务总量类型
          detail.taskTotalType = el.calcType;

          //任务要求
          detail.taskTag = el.taskTag && el.taskTag.length ? JSON.stringify(el.taskTag) : null;

          // 智能计算
          detail.isSmartCalculate = el.isSmartCalculate

          detailList.push(detail);
        });
      } catch (e) {
        this.$message.error(e.message);
        return;
      }
      if (detailList.length == 0) {
        self.$message.error('请添加系统功能');
        return;
      }

      console.log(detailList)
      let req = {
        ...detailList[0]
      };
      let requrl = req.guid ? '/template/detail/update' : '/template/detail/add'
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}${requrl}`, req).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.$message.success('保存成功');
          this.tableData[index].isEdit = !this.tableData[index].isEdit;
          this.getList();

        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //启用or禁用
    openOrClose(index) {
      this.$confirm(this.tableData[index].bizState == 'S' ? '启用后，该数据将被使用，确定操作吗?' : '禁用后，该数据将不可使用，确定操作吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          let req = {
            guid: this.tableData[index].guid,
            bizState: this.tableData[index].bizState == 'Y' ? 'S' : 'Y'
          };
          this.fullscreenLoading = true;
          this.api.postJson(`/${serverConfig.msSalesPerformService}/template/detail/update-state`, req).then((res) => {
            this.fullscreenLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              this.dialogVisible = false;
              this.$message.success('操作成功');
              this.getList();
            } else {
              this.$message.error(res.data.msg);
            }
          });
        })
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件`);
    },

    handleSelectionChange(val) {
      let self = this;
      self.tableData[this.currentIndex].multipleSelection = val;
    },
    btn(row, col, event) {
      row.flag = !row.flag;
      this.$refs.dataTable.toggleRowSelection(row, row.flag);
    },
    //获取图标数据
    getIconList() {
      let self = this;
      let req = {
        pageIndex: 1,
        pageSize: -1,
        totalPage: 0,
        totalRows: 0,
        bizType: '图标管理',
        paramName: '',
        // tenantGuid: localStorage.guid,
        // tenantName: JSON.parse(localStorage.userInfo).tenantName,
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/get-list`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.iconList = res.data.data.records;
          self.activeIcon = 0;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleClickMenu(index) {
      this.activeIcon = index;
    },
    chooseIcon(url) {
      this.chooseURL = url;
    },
    delPic() {
      this.tableData[this.currentIndex].fileList = [];
      this.$forceUpdate();
    },
    addPic() {
      if (this.tableData[this.currentIndex].fileList && this.tableData[this.currentIndex].fileList.length != 0) {
        this.$message.error('任务图标只能选择一个');
        return;
      }
      this.iconVisible = true;
    },
    moreSureIcon() {
      if (!this.chooseURL) {
        this.$message.error('请选择任务图标');
        return;
      }
      this.tableData[this.currentIndex].fileList = [
        {
          name: '任务图',
          url: this.chooseURL,
        },
      ];

      this.iconVisible = false;
      this.$forceUpdate();
    },
    // 切换智能计算
    changeComputed(row) {
      // 拦截前提是任务大类是[数据采集]且为[启用状态] , 
      if (row.taskType === '数据采集') {
        if (this.checkHaveComputed(row)) {
          this.$message.error('该系统功能已有一个智能计算标签')
          row.isSmartCalculate = 'N'
        } else if ((row.taskTotalUnit === '次' || row.taskTotalUnit === '条') && row.taskTotal === 1) { // 任务量为1的任务
          this.$message.error('请选择任务量单位为每执行一次即任务量为1的任务')
          row.isSmartCalculate = 'N'
        }
      } else {
        this.$message.error('只支持数据采集任务')
      }

    },
    // 判断当前启用的所有任务是否有智能计算
    checkHaveComputed(row) {
      let currentFnCode = row.taskContentType
      let sameFnList = this.allTempList.filter(item=>item.taskContentType === currentFnCode && item.bizState === 'Y' && item.isSmartCalculate === 'Y')
      return sameFnList.length
    },
    // 获取所有模板
    getAllTempList() {
      let param = {
        "pageIndex": 1,
        "pageSize": -1
      }
      return new Promise((resolve,reject)=>{
        this.api.postJson(`/${serverConfig.msSalesPerformService}/template/detail/get-detail-page-list`, param).then(res=>{
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.allTempList = res.data.data.records || [];
            resolve(list)
          }
        })
      })
    }
  },
};
</script> 
<style scoped>
.el-range-editor.el-input__inner {
  padding: 0px;
}

/deep/ .el-checkbox__label {
  display: none;
}

.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}

.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}

.content {
  background: #fff;
  font-size: 18px;
}

.title {
  text-align: left;
  font-size: 16px;
  font-weight: 500;
  background: #fff;
  color: #323233;
  padding: 16px 0 10px 20px;
  margin-bottom: 0;
}


.base-content {
  display: flex;
  font-size: 15px;
  padding-bottom: 20px;
  padding-top: 6px;
  background: #fff;
  margin-bottom: 4px;
}

.base-content .base-info {
  display: flex;
  align-items: center;
  padding: 0 40px;
}

.base-content .base-info .base-title {
  word-break: keep-all;
}

.button-area {
  display: flex;
  justify-content: flex-end;
  padding-left: 40px;
  margin-top: 0;
  padding-top: 0;
}

/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}

/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}

/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}

.icon-dialog {
  display: flex;
  overflow: hidden;
}

.icon-dialog .icon-left {
  width: 130px;
  text-align: left;
  border-right: 1px solid #cccc;
}

.icon-left .item {
  height: 40px;
  line-height: 40px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  padding: 0 20px;
}

.icon-dialog .icon-right {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  height: auto;
  padding-left: 10px;
}

.icon-right .pic {
  width: 100px;
  height: 130px;
  margin-right: 10px;
  margin-bottom: 10px;
}

.icon-right .pic .img {
  width: 100px;
  height: 100px;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.06);
}

.icon-right .pic .img:hover {
  border: 1px solid #4fa1a4;
  border-radius: 4px;
}

.img-wrap {
  position: relative;
}

.img-wrap .border-img {
  position: absolute;
  width: 100px;
  height: 100px;
  left: 0;
  top: 0;
}

.img-wrap .name {
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.file-img {
  width: 100%;
  height: 100%;
}

.icon-add {
  float: left;
  margin-left: 10px;
  width: 150px;
  height: 150px;
  border: 1px dotted #ccc;
  text-align: center;
  line-height: 150px;
}

.img-close {
  position: relative;
  float: left;
  width: 150px;
  height: 150px;
  margin-left: 20px;
}

.close {
  position: absolute;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
}

/deep/ .table_header {
  background-color: #F0F0F0 !important;
  padding: 10px 0;
  color: #323233;
}

.header {
  background: #fff;
  margin: 4px 0;
  font-size: 16px;
  text-align: center;
  line-height: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 16px;

}

.header .back {
  background: #FFFFFF;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  width: 60px;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
  cursor: pointer;
}

.header .task-title {
  flex: 1;
  font-weight: 500px;
}

.header .task-title span {
  font-size: 12px;
  color: #4fa1a4;
  margin-left: 5px;
  cursor: pointer;
}

.btn-groups {
  background: #fff;
}

.btn-groups .btn-common {
  width: 120px;
  margin-top: 20px;
  margin-bottom: 20px;
}

.btn-border-gray {
  background: #f0f0f0;
  color: #323233;
  border: 1px solid #dcdee0;
}
</style>
<style >
.icon-dialog-wrap .el-dialog__body {
  padding: 0;
  padding-top: 10px;
}

#template-config .el-dialog {
  height: 80vh;
  overflow: auto;
}

#template-config .el-form-item__content {
  margin-left: 15px !important;
}

#template-config .el-form-item {
  align-items: flex-start;
}

#template-config .calc-type .el-form-item__label {
  line-height: 15px;
}

.tips {
  margin: 14px 10px 0 -10px;

}
</style>